import "./loader.css";

const Loader = () => {
  return (
    <div className="boxloader">
      <div className="loader1">
        Creando
        <span></span>
      </div>
    </div>
  );
};

export default Loader;